@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class ConfigDto(
    val callCenterConfig: CallCenterConfigDto,
    val orderingIncentiveConfig: OrderingIncentiveConfigDto,
    val timeoutIncentiveConfig: TimeoutIncentiveConfigDto,
    val ipLockingConfig: IPLockingConfigDto,
    val targetConfig: TargetConfigDto,
    val contactUsConfigDto: ContactUsConfigDto,
    val smsConfigDto: SmsConfigDto,
    val termsAndConditionsConfigDto: TermsAndConditionsConfigDto,
)